import { ShareMessageFragment } from "~/__generated__/graphql"
import { HighlightedMessage } from "./highlighted-message"

interface TopMessagesSectionProps {
  messages: ShareMessageFragment[]
}

export const TopMessagesSection = ({ messages }: TopMessagesSectionProps) => {
  const sorted = [...messages].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )

  return (
    <div className="flex flex-col px-4">
      {sorted.map((message) => (
        <div key={message.id} className="gap-3 py-4">
          <HighlightedMessage message={message} showHeader={false} compact={true} />
        </div>
      ))}
    </div>
  )
}
